import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Button, Spinner, Alert } from "react-bootstrap";
import { MonitorStripeApiApi } from "./shared/api/axios-client";
import { createApiService } from "./shared/apiConfig";
import { ClipboardIcon } from "./Controls/ClipboardIcon";
import { Copy } from "react-bootstrap-icons";

export default function RefreshOnboardingPage() {
  const { facilityId } = useParams<{ facilityId: string }>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>();
  const [link, setLink] = useState<string>();
  const stripeApi = createApiService(MonitorStripeApiApi);

  useEffect(() => {
    const refreshLink = async () => {
      try {
        const res = await stripeApi.monitorStripeFacilityIdLinkGet({
          facilityId: Number(facilityId),
        });

        if (!res.data.isOnboarded) {
          setLink(res.data.connectLink!);
        } else {
          setError("This account is already onboarded.");
        }
      } catch (err: any) {
        setError(err.message || "Error refreshing link");
      } finally {
        setLoading(false);
      }
    };

    refreshLink();
  }, [facilityId]);

  if (loading) return <Spinner animation="border" />;

  if (error) return <Alert variant="danger">Error: {error}</Alert>;

  return (
    <div
      style={{
        padding: "2rem",
        textAlign: "center",
        maxWidth: "800px", 
        margin: "0 auto", 
      }}
    >
      <h3>Your onboarding link has expired or was already used</h3>
      <p>We are generating a new one-time link for you...</p>

      {link && (
        <>
          <Alert variant="success" className="text-start">
            <strong>New Onboarding Link:</strong>
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                value={link}
                readOnly
                onFocus={(e) => e.target.select()}
              />
              <span className="input-group-text">
                <ClipboardIcon
                  payload={link}
                  tooltipText="Link copied!"
                  icon={<Copy className="small" />}
                />
              </span>
              <div className="mt-3 text-muted">
                Please note this is a one-time link and will expire in 5 minutes.  A new link will be generated automatically if you don't follow the onboarding link within 5 minutes.
              </div>
            </div>
          </Alert>
          <Button href={link} target="_blank">
            Go to Onboarding
          </Button>
        </>
      )}
    </div>
  );
}
